import { createSelector, createStructuredSelector } from "reselect";
import { selectUserName } from "scenes/selectors";
import { initialState, State as AppAuthenticatorsState } from "./redux";

/**
 * Direct selector to the appAuthenticators state domain
 */

const selectAppAuthenticatorsDomain: (any) => AppAuthenticatorsState = (
  state
) => state.appAuthenticators || initialState;

/**
 * Custom selectors to the appAuthenticators state
 */
export const selectAppAuthenticators = createSelector(
  selectAppAuthenticatorsDomain,
  (substate) => substate
);

export const currentFlow = createSelector(
  selectAppAuthenticators,
  (subState) => subState.currentFlow
);

export const selectQRCode = createSelector(
  selectAppAuthenticatorsDomain,
  (substate) => substate.qrCodeLink
);

export const selectQRLinkSubmission = createSelector(
  selectAppAuthenticatorsDomain,
  (substate) => substate.loadingPassCodeSubmission
);

export const selectError = createSelector(
  selectAppAuthenticatorsDomain,
  (substate) => substate.showError
);

export const selectStatus = createSelector(
  selectAppAuthenticatorsDomain,
  (substate) => substate.status
);

export const selectSecretCode = createSelector(
  selectAppAuthenticatorsDomain,
  (substate) => substate.secretCode
);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  qrCodeLink: selectQRCode,
  loadingPassCodeSubmission: selectQRLinkSubmission,
  showError: selectError,
  status: selectStatus,
  secretCode: selectSecretCode,
  username: selectUserName,
  currentFlow,
});
